// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox
input[type=number] {
  -moz-appearance: textfield;
} */
/* 
.flex-1.transition-all.duration-300.ml-64 {
  overflow-y: hidden;
} */


/* Remove spinner (arrows) for number inputs */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] { /* For Firefox */
  appearance: textfield; /* General appearance reset */
}






`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;;;GAGG;AACH;;;GAGG;;;AAGH,8CAA8C;AAC9C;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,uBAC8B,gBAAgB;EAC5C,qBAAqB,EAAE,6BAA6B;AACtD","sourcesContent":["\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox\ninput[type=number] {\n  -moz-appearance: textfield;\n} */\n/* \n.flex-1.transition-all.duration-300.ml-64 {\n  overflow-y: hidden;\n} */\n\n\n/* Remove spinner (arrows) for number inputs */\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield; /* For Firefox */\n  appearance: textfield; /* General appearance reset */\n}\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
